<div class="col-12" style="height:20vh">
</div>
<div class="flex flex-column align-items-center">
  <div class="grid">
    <div class="col-6">
    </div>
    <div class="col-12">
      <div class="logo">
        {{ 'Wait' | translate }}
      </div>
      <div class="loadermsg">
        {{ message }}
        @if (displayPbar === true) {
            <p-progressBar
              [showValue]="false"
              [value]="pBarValue"
              [style]="{ height: '15px', width: '100%', 'margin-top': '15px' }"
            ></p-progressBar>
            <div class="p-bar">{{ pBarValue }} %</div>
        }@else {
          <div id="floatingCirclesG">
            <p-progressSpinner></p-progressSpinner>
          </div>
        }
      </div>
    </div>
  </div>
</div>
